<script setup>
import { isDarkMode } from "@/darkmode.js";
import { RouterView } from "vue-router";
</script>

<style scoped>
div {
  min-height: 100dvh;
  background-color: var(--background); 
  /* Why are we using var(--card) for the background color? */
}
</style>

<template>
  <div v-if="isDarkMode" class="dark" data-theme="dark">
    <RouterView />
  </div>
  <div v-if="!isDarkMode">
    <RouterView />
  </div>
</template>
